var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _emit, _addOpenListeners, addOpenListeners_fn, _removeOpenListeners, removeOpenListeners_fn, _focusOnTrigger, focusOnTrigger_fn, _handlePanelSelect, _handleKeyDown, _handleDocumentKeyDown, _handleDocumentMouseDown, _getMenu, getMenu_fn, _handleTriggerClick, handleTriggerClick_fn, _handleTriggerKeyDown, handleTriggerKeyDown_fn, _handleTriggerKeyUp, handleTriggerKeyUp_fn, _handleTriggerSlotChange, handleTriggerSlotChange_fn, _updateAccessibleTrigger, updateAccessibleTrigger_fn;
import { LitElement, html } from "@horizon/base";
import { ScopedElementsMixin } from "@open-wc/scoped-elements";
import DropdownStyles from "./dropdown.css.js";
import { SlPopup } from "@horizon/common/components";
import { property, query } from "@horizon/base/decorators";
import { watch } from "@horizon/common/decorators";
import { eventEmitter } from "@horizon/common/events";
import { animateTo, stopAnimations, getTabbableBoundary } from "@horizon/common/helpers";
class HznDropdown extends ScopedElementsMixin(LitElement) {
  constructor() {
    super(...arguments);
    /**
     * @private
     */
    __privateAdd(this, _addOpenListeners);
    /**
     * @private
     */
    __privateAdd(this, _removeOpenListeners);
    /**
     * @private
     */
    __privateAdd(this, _focusOnTrigger);
    /**
     * @private
     */
    __privateAdd(this, _getMenu);
    /**
     * @private
     */
    __privateAdd(this, _handleTriggerClick);
    /**
     * @private
     */
    __privateAdd(this, _handleTriggerKeyDown);
    /**
     * @private
     */
    __privateAdd(this, _handleTriggerKeyUp);
    /**
     * @private
     */
    __privateAdd(this, _handleTriggerSlotChange);
    //
    // Slotted triggers can be arbitrary content, but we need to link them to the dropdown panel with `aria-haspopup` and
    // `aria-expanded`. These must be applied to the "accessible trigger" (the tabbable portion of the trigger element
    // that gets slotted in) so screen readers will understand them. The accessible trigger could be the slotted element,
    // a child of the slotted element, or an element in the slotted element's shadow root.
    //
    // For example, the accessible trigger of an <sl-button> is a <button> located inside its shadow root.
    //
    // To determine this, we assume the first tabbable element in the trigger slot is the "accessible trigger."
    //
    /**
     * @private
     */
    __privateAdd(this, _updateAccessibleTrigger);
    /**
     * @private
     */
    __privateAdd(this, _emit, eventEmitter(this));
    this.show = false;
    this.alignX = "start";
    this.width = "content";
    this.disabled = false;
    /**
     * @private
     */
    __privateAdd(this, _handlePanelSelect, (event) => {
      event.stopImmediatePropagation();
      event.preventDefault();
      __privateGet(this, _emit).call(this, {
        type: "select",
        callback() {
          this.show = false;
          __privateMethod(this, _focusOnTrigger, focusOnTrigger_fn).call(this);
        }
      });
    });
    /**
     * @private
     */
    __privateAdd(this, _handleKeyDown, (event) => {
      if (this.show && event.key === "Escape") {
        event.stopPropagation();
        this.show = false;
        __privateMethod(this, _focusOnTrigger, focusOnTrigger_fn).call(this);
      }
    });
    /**
     * @private
     */
    __privateAdd(this, _handleDocumentKeyDown, (event) => {
      var _a;
      if (event.key === "Escape" && this.show) {
        event.stopPropagation();
        __privateMethod(this, _focusOnTrigger, focusOnTrigger_fn).call(this);
        this.show = false;
        return;
      }
      if (event.key === "Tab") {
        if (this.show && ((_a = document.activeElement) == null ? void 0 : _a.tagName.toLowerCase()) === "hzn-menu-item") {
          event.preventDefault();
          this.show = false;
          __privateMethod(this, _focusOnTrigger, focusOnTrigger_fn).call(this);
          return;
        }
        setTimeout(() => {
          var _a2, _b, _c;
          const activeElement = ((_a2 = this.containerElement) == null ? void 0 : _a2.getRootNode()) instanceof ShadowRoot ? (_c = (_b = document.activeElement) == null ? void 0 : _b.shadowRoot) == null ? void 0 : _c.activeElement : document.activeElement;
          if (!this.containerElement || (activeElement == null ? void 0 : activeElement.closest(this.containerElement.tagName.toLowerCase())) !== this.containerElement) {
            this.show = false;
          }
        });
      }
    });
    /**
     * @private
     */
    __privateAdd(this, _handleDocumentMouseDown, (event) => {
      const path = event.composedPath();
      if (this.containerElement && !path.includes(this.containerElement)) {
        this.show = false;
      }
    });
  }
  /**
   * @private
   */
  static get scopedElements() {
    return {
      "hzn-popup": SlPopup
    };
  }
  /**
   * @private
   */
  get containerElement() {
    if (this.container) {
      const container = document.querySelector(this.container);
      return container ? document.querySelector(this.container) : this;
    }
    return this;
  }
  connectedCallback() {
    super.connectedCallback();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    __privateMethod(this, _removeOpenListeners, removeOpenListeners_fn).call(this);
  }
  async handleOpenChange() {
    if (this.disabled) {
      this.show = false;
      return;
    }
    __privateMethod(this, _updateAccessibleTrigger, updateAccessibleTrigger_fn).call(this);
    if (this.show) {
      __privateGet(this, _emit).call(this, { type: "show" });
      __privateMethod(this, _addOpenListeners, addOpenListeners_fn).call(this);
      await stopAnimations(this);
      this.panel.hidden = false;
      this.popup.active = true;
      await animateTo(this.popup.popup, [
        { opacity: 0, scale: 0.9 },
        { opacity: 1, scale: 1 }
      ], { duration: 100, easing: "ease" });
    } else {
      __privateGet(this, _emit).call(this, { type: "hide" });
      __privateMethod(this, _removeOpenListeners, removeOpenListeners_fn).call(this);
      await stopAnimations(this);
      await animateTo(this.popup.popup, [
        { opacity: 1, scale: 1 },
        { opacity: 0, scale: 0.9 }
      ], { duration: 100, easing: "ease" });
      this.panel.hidden = true;
      this.popup.active = false;
      const menu = __privateMethod(this, _getMenu, getMenu_fn).call(this);
      if (menu && typeof menu.getAllItems === "function") {
        menu.getAllItems().forEach((item, index) => {
          item.setAttribute("tabindex", index === 0 ? "0" : "-1");
        });
      }
    }
  }
  render() {
    return html`
      <hzn-popup
        id="dropdown"
        placement="bottom-${this.alignX}"
        distance="12"
        skidding="0"
        strategy="fixed"
        flip
        shift
        auto-size="vertical"
        auto-size-padding="10"
        ?active="${this.show}"
        class="dropdown"
      >
        <slot
          role="none"
          name="trigger"
          slot="anchor"
          class="trigger"
          @click=${__privateMethod(this, _handleTriggerClick, handleTriggerClick_fn)}
          @keydown=${__privateMethod(this, _handleTriggerKeyDown, handleTriggerKeyDown_fn)}
          @keyup=${__privateMethod(this, _handleTriggerKeyUp, handleTriggerKeyUp_fn)}
          @slotchange=${__privateMethod(this, _handleTriggerSlotChange, handleTriggerSlotChange_fn)}
        ></slot>

        <div aria-hidden=${this.show ? "false" : "true"} aria-labelledby="dropdown">
          <slot class="panel"></slot>
        </div>
      </hzn-popup>
    `;
  }
}
_emit = new WeakMap();
_addOpenListeners = new WeakSet();
addOpenListeners_fn = function() {
  this.panel.addEventListener("keydown", __privateGet(this, _handleKeyDown));
  this.panel.addEventListener("select", __privateGet(this, _handlePanelSelect));
  document.addEventListener("keydown", __privateGet(this, _handleDocumentKeyDown));
  document.addEventListener("mousedown", __privateGet(this, _handleDocumentMouseDown));
};
_removeOpenListeners = new WeakSet();
removeOpenListeners_fn = function() {
  if (this.panel) {
    this.panel.removeEventListener("keydown", __privateGet(this, _handleKeyDown));
    this.panel.removeEventListener("select", __privateGet(this, _handlePanelSelect));
  }
  document.removeEventListener("keydown", __privateGet(this, _handleDocumentKeyDown));
  document.removeEventListener("mousedown", __privateGet(this, _handleDocumentMouseDown));
};
_focusOnTrigger = new WeakSet();
focusOnTrigger_fn = function() {
  const trigger = this.trigger.assignedElements({ flatten: true })[0];
  if (typeof (trigger == null ? void 0 : trigger.focus) === "function") {
    trigger.focus();
  }
};
_handlePanelSelect = new WeakMap();
_handleKeyDown = new WeakMap();
_handleDocumentKeyDown = new WeakMap();
_handleDocumentMouseDown = new WeakMap();
_getMenu = new WeakSet();
getMenu_fn = function() {
  return this.panel.assignedElements({ flatten: true }).find((el) => el.getAttribute("role") === "menu");
};
_handleTriggerClick = new WeakSet();
handleTriggerClick_fn = function() {
  if (this.show) {
    this.show = false;
  } else {
    this.show = true;
    __privateMethod(this, _focusOnTrigger, focusOnTrigger_fn).call(this);
  }
};
_handleTriggerKeyDown = new WeakSet();
handleTriggerKeyDown_fn = function(event) {
  if ([" ", "Enter"].includes(event.key)) {
    event.preventDefault();
    __privateMethod(this, _handleTriggerClick, handleTriggerClick_fn).call(this);
    return;
  }
  const menu = __privateMethod(this, _getMenu, getMenu_fn).call(this);
  if (menu && typeof menu.getAllItems === "function") {
    const menuItems = menu.getAllItems();
    const firstMenuItem = menuItems[0];
    const lastMenuItem = menuItems[menuItems.length - 1];
    if (["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) {
      event.preventDefault();
      if (!this.show) {
        this.show = true;
      }
      if (menuItems.length > 0) {
        this.updateComplete.then(() => {
          if (event.key === "ArrowDown" || event.key === "Home") {
            menu.setCurrentItem(firstMenuItem);
            firstMenuItem.focus();
          }
          if (event.key === "ArrowUp" || event.key === "End") {
            menu.setCurrentItem(lastMenuItem);
            lastMenuItem.focus();
          }
        });
      }
    }
  }
};
_handleTriggerKeyUp = new WeakSet();
handleTriggerKeyUp_fn = function(event) {
  if (event.key === " ") {
    event.preventDefault();
  }
};
_handleTriggerSlotChange = new WeakSet();
handleTriggerSlotChange_fn = function() {
  __privateMethod(this, _updateAccessibleTrigger, updateAccessibleTrigger_fn).call(this);
};
_updateAccessibleTrigger = new WeakSet();
updateAccessibleTrigger_fn = function() {
  const assignedElements = this.trigger.assignedElements({ flatten: true });
  const accessibleTrigger = assignedElements.find((el) => getTabbableBoundary(el).start);
  let target;
  if (accessibleTrigger) {
    switch (accessibleTrigger.tagName.toLowerCase()) {
      case "hzn-button":
      case "hzn-icon-button":
        target = accessibleTrigger.innerButton;
        break;
      default:
        target = accessibleTrigger;
    }
    target.setAttribute("aria-haspopup", "true");
    target.setAttribute("aria-expanded", this.show ? "true" : "false");
  }
};
/**
 * @private
 */
HznDropdown.styles = [DropdownStyles];
__decorateClass([
  query(".dropdown")
], HznDropdown.prototype, "popup", 2);
__decorateClass([
  query(".trigger")
], HznDropdown.prototype, "trigger", 2);
__decorateClass([
  query(".panel")
], HznDropdown.prototype, "panel", 2);
__decorateClass([
  property({ type: Boolean })
], HznDropdown.prototype, "show", 2);
__decorateClass([
  property({ type: String, attribute: "align-x" })
], HznDropdown.prototype, "alignX", 2);
__decorateClass([
  property({ type: String })
], HznDropdown.prototype, "width", 2);
__decorateClass([
  property({ type: Boolean })
], HznDropdown.prototype, "disabled", 2);
__decorateClass([
  property({ type: String })
], HznDropdown.prototype, "container", 2);
__decorateClass([
  watch("show", { waitUntilFirstUpdate: true })
], HznDropdown.prototype, "handleOpenChange", 1);
export {
  HznDropdown
};
//# sourceMappingURL=dropdown.js.map
